import * as styles from "./MongoliaDataDetail.module.scss";

import { ADMIN_USER_ROLE, DATA_TEAM_USER_ROLE } from "common/constants";

import FormFooter from "components/common/FormFooter/FormFooter";
import MongoliaDataFormField from "./MongoliaDataFormField";
import MongoliaDataActions from "./MongoliaDataActions";
import classNames from "classnames";
import { getUserProperty } from "common/utils/authenticationUtils";
import { useState } from "react";

const MongoliaDataForm = ({ record, refetchRecord }) => {
  const userRole = getUserProperty("user_role");
  const isAdminUser = [DATA_TEAM_USER_ROLE, ADMIN_USER_ROLE].includes(userRole);

  const [formDetails, setFormDetails] = useState(record);

  const wrapperClasses = classNames(
    styles.Mongolia_Data_Form_Field_Wrapper,
    "d-flex align-items-center gap-4 py-2"
  );

  return (
    <form className="pb-5">
      {Object.keys(record).map((recordKey, index) => {
        return (
          <MongoliaDataFormField
            key={index}
            {...{
              recordKey,
              formDetails,
              setFormDetails,
              isAdminUser,
              wrapperClasses,
            }}
          />
        );
      })}
      {isAdminUser && (
        <FormFooter
          {...{
            showClearFormButton: false,
          }}>
          <MongoliaDataActions
            {...{ formDetails, record, refetchRecord, setFormDetails }}
          />
        </FormFooter>
      )}
    </form>
  );
};

export default MongoliaDataForm;
